import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { getNotic } from '../Store/ActionCreators/NotifactionActionCreator'
import { getContact } from '../Store/ActionCreators/ContactActionCreator'
import { getCategory } from '../Store/ActionCreators/CategoryActionCreator'
import { getUser } from '../Store/ActionCreators/UserActionCreator'
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useNavigate } from 'react-router-dom'

export default function Dashboard() {
  const dispatch = useDispatch()
  const NotifactionList = useSelector((state)=>state.NoticStateData)
  const ContactList = useSelector((state)=>state.ContactStateData)
  const CategoryList= useSelector((state)=>state.CategoryStateData)
 const UserList = useSelector((state) => state.UserStateData);
const [data, setData] = useState({});
  const navigate = useNavigate()
useEffect(() => {
  const userid = sessionStorage.getItem("userid");
  const token = sessionStorage.getItem("token");

  if (!userid || !token) {
    console.log("User not logged in");
    return;
  }

  async function getAdminData() {
    try {
      const response = await fetch(
        "https://msdskserver.onrender.com/api/user/" + userid,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.result === "Done") {
        setData(result.data);
      } else {
        console.log(result.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  }

  getAdminData();
}, []);

function Logout(){
  sessionStorage.clear()
  navigate("/login")
}

  useEffect(() => {
  dispatch(getNotic());
  dispatch(getContact());
  dispatch(getCategory());
  dispatch(getUser());
}, [dispatch]);

  return (
    <Box sx={{ display: "flex" ,width:"100%" }}>
      <Sidebar />
      <Box className="boxStyle">
        <marquee bgcolor="yellowgreen"
          direction="left" loop="" className="text-danger p-2 rounded">
          <div className="geek2">
            <h6 className='pt-1'>WELCOME TO MAA SHARDE DIGITAL SEVA KENDRA</h6>
          </div>
        </marquee>
        <div className="row mx-1"style={{justifyContent:"space-around"}}>
          <div className="col-md-8">
              <img src="assets/images/banner_1.jpg" className='img-fluid' alt="no banner" />
          </div>
          <div className="col-md-3 mt-2">
                <div className="AdminInfo ">
                <h4 className='headerAdmin'>Admin Details</h4>
                <div className="NameDetails">
                  <div className="profile_Img">
                    <img src="/assets/images/avtar.png" alt="no profile_picture" />
                  </div>
                  <div className="profile_name" style={{height:"140px"}}>
                    <h4>{data.name}</h4>
                    <h5>Mobile:- {data.mobile}</h5>
                    <h6 style={{marginRight:"10px"}}>Email:-{data.email}</h6>
                    <div className="d-flex justify-content-center mt-3">
                      <Button className="bg-success text-light"  style={{ fontSize: "10px", fontWeight: "bold" }} onClick={Logout}>
                        <LogoutIcon style={{ fontSize: "16px", marginRight: "5px" }}/> Sign out
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div className="row mt-3" style={{padding:"0 45px 0 50px"}}>
          <div className="col">
            <div className="card" style={{border:"1px solid #8b8b8bff", alignItems:"center", boxShadow:"0px 0px 8px #5f5f5fff"}}>
              <img src="/assets/images/notifaction.png" alt="notifaction_images" style={{height:"150px", width:"150px"}}/>
              <br />
              <h4>Notifaction</h4>
              <p>Total : {NotifactionList.length}</p>
            </div>
          </div>
          <div className="col">
            <div className="card" style={{border:"1px solid #8b8b8bff", alignItems:"center", boxShadow:"0px 0px 8px #5f5f5fff"}}>
              <img src="/assets/images/category.png" alt="category_images" style={{height:"150px", width:"150px"}}/>
              <br />
              <h4>Category</h4>
              <p>Total : {CategoryList.length}</p>
            </div>
          </div>
          <div className="col">
            <div className="card" style={{border:"1px solid #8b8b8bff", alignItems:"center", boxShadow:"0px 0px 8px #5f5f5fff"}}>
              <img src="/assets/images/contact.png" alt="contact_images" style={{height:"150px", width:"150px"}}/>
              <br />
              <h4>Contact Request</h4>
              <p>Total : {ContactList.length}</p>
            </div>
          </div>
          <div className="col">
            <div className="card" style={{border:"1px solid #8b8b8bff", boxShadow:"0px 0px 8px #5f5f5fff"}}>
              <div className="text-center">
                <img src="/assets/images/request.png" alt="user_images" style={{height:"150px", width:"150px", alignItems:"center"}}/>
                <br />
                <h4 className='mt-4'>Request Form</h4>
                <p>Total : 0</p>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Box>
  )
}
